<template>
  <div>
    <a-card title="短信统计">
         <!-- 搜索框 -->
      <a-form layout="inline" @submit="handleSubmit" :form="form">
         <a-form-model-item  label="开始日期" prop="starttime">
            <a-date-picker v-model="searchP.starttime" format="YYYY-MM-DD" />
         </a-form-model-item>
         <a-form-model-item  label="结束日期" prop="endtime">
            <a-date-picker  v-model="searchP.endtime"   format="YYYY-MM-DD" />
         </a-form-model-item>
          <a-form-item>
                <a-button type="primary" htmlType="submit" :key="this.loading.key">筛选</a-button>
          </a-form-item>

          <a-form-item>
                <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                </a-button>
          </a-form-item>
      </a-form>

       <a-tabs type="card"  default-active-key="errorcode" @change="callback" style="top:10px;bottom:30px">
            <a-tab-pane key="1" tab="总发送"> 
                <a-row :gutter="16">
                    <a-col :span="4">
                        <a-card>
                            <a-statistic
                                title="总发送数(按字数)"
                                :value="totalSendNum"
                                :value-style="{ color: '#3f8600' }"
                                style="margin-right: 50px"
                            >
                            </a-statistic>
                        </a-card>
                    </a-col>
                    <a-col :span="4">
                        <a-card>
                            <a-statistic
                                title="中仑平台(按字数)"
                                :value="plateformNum"
                                class="demo-class"
                                :value-style="{ color: '#3f8600' }"
                            >
                        </a-statistic>
                        </a-card>
                    </a-col>
                    <a-col :span="4">
                        <a-card>
                            <a-statistic
                                title="动态签名(按字数)"
                                :value="dynamicNum"
                                :value-style="{ color: '#3f8600' }"
                                style="margin-right: 50px"
                            >
                            </a-statistic>
                        </a-card>
                    </a-col>
                    <a-col :span="4">
                        <a-card>
                            <a-statistic
                                title="商户(按字数)"
                                :value="shopNum"
                                class="demo-class"
                                :value-style="{ color: '#3f8600' }"
                            >
                        </a-statistic>
                        </a-card>
                    </a-col>
                </a-row>

                <a-row :gutter="16">
                    <a-col :span="4">
                        <a-card>
                            <a-statistic
                                title="总发送数(按条数)"
                                :value="realtotalSendNum"
                                :value-style="{ color: '#3f8600' }"
                                style="margin-right: 50px"
                            >
                            </a-statistic>
                        </a-card>
                    </a-col>
                    <a-col :span="4">
                        <a-card>
                            <a-statistic
                                title="中仑平台(按条数)"
                                :value="realplateformNum"
                                class="demo-class"
                                :value-style="{ color: '#3f8600' }"
                            >
                        </a-statistic>
                        </a-card>
                    </a-col>
                    <a-col :span="4">
                        <a-card>
                            <a-statistic
                                title="动态签名(按条数)"
                                :value="realdynamicNum"
                                :value-style="{ color: '#3f8600' }"
                                style="margin-right: 50px"
                            >
                            </a-statistic>
                        </a-card>
                    </a-col>
                    <a-col :span="4">
                        <a-card>
                            <a-statistic
                                title="商户(按条数)"
                                :value="realshopNum"
                                class="demo-class"
                                :value-style="{ color: '#3f8600' }"
                            >
                        </a-statistic>
                        </a-card>
                    </a-col>
                </a-row>

                  <div  id="chartname2" style="padding-right:20px;border:1px solid gray"> </div> 
           </a-tab-pane>

           <a-tab-pane key="2" tab="发送失败" force-render>
                <a-row :gutter="16">
                    <a-col :span="4">
                        <a-card>
                            <a-statistic
                                title="总失败数"
                                :value="totalSendNumF"
                                :value-style="{ color: '#cf1322' }"
                                style="margin-right: 50px"
                            >
                            </a-statistic>
                        </a-card>
                    </a-col>
                    <a-col :span="4">
                        <a-card>
                            <a-statistic
                                title="中仑平台"
                                :value="plateformNumF"
                                class="demo-class"
                                :value-style="{ color: '#cf1322' }"
                            >
                        </a-statistic>
                        </a-card>
                    </a-col>
                    <a-col :span="4">
                        <a-card>
                            <a-statistic
                                title="动态签名"
                                :value="dynamicNumF"
                                :value-style="{ color: '#cf1322' }"
                                style="margin-right: 50px"
                            >
                            </a-statistic>
                        </a-card>
                    </a-col>
                    <a-col :span="4">
                        <a-card>
                            <a-statistic
                                title="商户"
                                :value="shopNumF"
                                class="demo-class"
                                :value-style="{ color: '#cf1322' }"
                            >
                        </a-statistic>
                        </a-card>
                    </a-col>
                </a-row>

                <a-row :gutter="16">
                    <a-col :span="4">
                        <a-card>
                            <a-statistic
                                title="真.总失败数"
                                :value="realtotalSendNumF"
                                :value-style="{ color: '#cf1322' }"
                                style="margin-right: 50px"
                            >
                            </a-statistic>
                        </a-card>
                    </a-col>
                    <a-col :span="4">
                        <a-card>
                            <a-statistic
                                title="真.中仑平台"
                                :value="realplateformNumF"
                                class="demo-class"
                                :value-style="{ color: '#cf1322' }"
                            >
                        </a-statistic>
                        </a-card>
                    </a-col>
                    <a-col :span="4">
                        <a-card>
                            <a-statistic
                                title="真.动态签名"
                                :value="realdynamicNumF"
                                :value-style="{ color: '#cf1322' }"
                                style="margin-right: 50px"
                            >
                            </a-statistic>
                        </a-card>
                    </a-col>
                    <a-col :span="4">
                        <a-card>
                            <a-statistic
                                title="真.商户"
                                :value="realshopNumF"
                                class="demo-class"
                                :value-style="{ color: '#cf1322' }"
                            >
                        </a-statistic>
                        </a-card>
                    </a-col>
                </a-row>

                <div  id="chartname3" style="padding-right:20px;border:1px solid gray"> </div> 

            </a-tab-pane>

            <a-tab-pane key="3" tab="发送中" force-render>
                <a-row :gutter="16">
                    <a-col :span="4">
                        <a-card>
                            <a-statistic
                                title="总发送中"
                                :value="totalSendNumING"
                                :value-style="{ color: '#000080' }"
                                style="margin-right: 50px"
                            >
                            </a-statistic>
                        </a-card>
                    </a-col>
                    <a-col :span="4">
                        <a-card>
                            <a-statistic
                                title="中仑平台"
                                :value="plateformNumING"
                                class="demo-class"
                                :value-style="{ color: '#000080' }"
                            >
                        </a-statistic>
                        </a-card>
                    </a-col>
                    <a-col :span="4">
                        <a-card>
                            <a-statistic
                                title="动态签名"
                                :value="dynamicNumING"
                                :value-style="{ color: '#000080' }"
                                style="margin-right: 50px"
                            >
                            </a-statistic>
                        </a-card>
                    </a-col>
                    <a-col :span="4">
                        <a-card>
                            <a-statistic
                                title="商户"
                                :value="shopNumING"
                                class="demo-class"
                                :value-style="{ color: '#000080' }"
                            >
                        </a-statistic>
                        </a-card>
                    </a-col>
                </a-row>

                <a-row :gutter="16">
                    <a-col :span="4">
                        <a-card>
                            <a-statistic
                                title="真.总发送中"
                                :value="realtotalSendNumING"
                                :value-style="{ color: '#000080' }"
                                style="margin-right: 50px"
                            >
                            </a-statistic>
                        </a-card>
                    </a-col>
                    <a-col :span="4">
                        <a-card>
                            <a-statistic
                                title="真.中仑平台"
                                :value="realplateformNumING"
                                class="demo-class"
                                :value-style="{ color: '#000080' }"
                            >
                        </a-statistic>
                        </a-card>
                    </a-col>
                    <a-col :span="4">
                        <a-card>
                            <a-statistic
                                title="真.动态签名"
                                :value="realdynamicNumING"
                                :value-style="{ color: '#000080' }"
                                style="margin-right: 50px"
                            >
                            </a-statistic>
                        </a-card>
                    </a-col>
                    <a-col :span="4">
                        <a-card>
                            <a-statistic
                                title="真.商户"
                                :value="realshopNumING"
                                class="demo-class"
                                :value-style="{ color: '#000080' }"
                            >
                        </a-statistic>
                        </a-card>
                    </a-col>
                </a-row>

                <div  id="chartname5" style="padding-right:20px;border:1px solid gray"> </div> 
            </a-tab-pane>

            <a-tab-pane key="analysisDate" tab="时间轴-柱状图"> 
                  <div  id="chartname1" style="padding-right:20px;border:1px solid gray"> </div> 
            </a-tab-pane>
           <a-tab-pane key="analysisDate_line" tab="时间轴-折线图"> 
                  <div  id="chartname4" style="padding-right:20px;border:1px solid gray"> </div> 
            </a-tab-pane>
        </a-tabs>   

    </a-card>

   
  </div>
</template>
<script>
import { mapState } from "vuex";
const data = [];

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            data,
            tLoading:true,
            totalSendNum:'',
            plateformNum:'',
            dynamicNum:'',
            shopNum:'',
            realtotalSendNum:'',
            realplateformNum:'',
            realdynamicNum:'',
            realshopNum:'',
            totalSendNumF:'',
            plateformNumF:'',
            dynamicNumF:'',
            shopNumF:'',
            realtotalSendNumF:'',
            realplateformNumF:'',
            realdynamicNumF:'',
            realshopNumF:'',
            totalSendNumING:'',
            plateformNumING:'',
            dynamicNumING:'',
            shopNumING:'',
            realtotalSendNumING:'',
            realplateformNumING:'',
            realdynamicNumING:'',
            realshopNumING:'',
            analysisdateDataList:[],
            analysisfailDataList:[],
            analysisdateChart:null,
            analysisfailChart:null,
            analysistype:'1'
        };
    },
    methods: {

        callback(key) {
            console.log(key);
            if((key=='analysisDate' ||key=='analysisDate_line') &&(this.searchP.starttime=='' && this.searchP.endtime=='' )){
                this.analysistype=key;
                return;
            }
            this.getSmsAnalysis(key);        

        },

        // 查询 短信发送统计
        getSmsAnalysis(key){

            let c_params = {
                ...this.searchP
            }
            let urlreq='';
            if(key==1){// 全部
                this.analysistype='1';
                urlreq='smsmanager/querySendNumbersAnalysis';
            }else if(key==2){ //失败
                this.analysistype='2';
                c_params.status='0';
                urlreq='smsmanager/querySendNumbersAnalysisFailNumber';
            }else if(key==3){// 发送中
                c_params.status='2';
                this.analysistype='3';
                urlreq='smsmanager/querySendNumbersAnalysisFailNumber';
            }else if(key=='analysisDate'){
                this.analysistype='analysisDate';
                urlreq='smsmanager/querySendNumbersAnalysisByDate';
            }else if(key=='analysisDate_line'){
                this.analysistype='analysisDate_line';
                urlreq='smsmanager/querySendFailedNumbersAnalysis';
            }
            console.log('analysistype==='+key);
            console.log('urlreq==='+urlreq);

            c_params.endtime = c_params.endtime ?  this.dateFormat('YYYY-mm-dd',new Date(c_params.endtime)) : '';
            c_params.starttime =c_params.starttime ? this.dateFormat('YYYY-mm-dd',new Date(c_params.starttime)): '';
            this.tLoading = true;
            this.$store.dispatch({
                type: urlreq,
                params:c_params
            }).then((res)=>{
                console.log(res);
                this.tLoading = false;
                let result = res.data.data;
                if(result){
                    if(key==1){ // 发送总统计
                        this.totalSendNum = result.totalSendNum;
                        this.plateformNum = result.plateformNum;
                        this.dynamicNum = result.dynamicNum;
                        this.shopNum = result.shopNum;
                        this.realtotalSendNum = result.realtotalSendNum;
                        this.realplateformNum = result.realplateformNum;
                        this.realdynamicNum = result.realdynamicNum;
                        this.realshopNum = result.realshopNum;

                        // 饼图数据
                        this.analysisdateDataList = res.data.data;
                        document.getElementById("chartname2").style.height = "500px";
                        this.analysisdateChart = this.$echarts.init(document.getElementById("chartname2"));
                        let optionA = this.getPieOption(this.analysisdateDataList);
                        this.analysisdateChart.setOption(optionA);
                        this.data_failrate=  res.data.data.detailList;   

                    }else if(key==2){ //发送失败统计
                        this.totalSendNumF = result.totalSendNumF;
                        this.plateformNumF = result.plateformNumF;
                        this.dynamicNumF = result.dynamicNumF;
                        this.shopNumF = result.shopNumF;
                        this.realtotalSendNumF = result.realtotalSendNumF;
                        this.realplateformNumF = result.realplateformNumF;
                        this.realdynamicNumF = result.realdynamicNumF;
                        this.realshopNumF = result.realshopNumF;

                        // 饼图数据
                        this.analysisdateDataList = res.data.data;
                        document.getElementById("chartname3").style.height = "500px";
                        this.analysisdateChart = this.$echarts.init(document.getElementById("chartname3"));
                        let optionA = this.getPieOption(this.analysisdateDataList);
                        this.analysisdateChart.setOption(optionA);
                        this.data_failrate=  res.data.data.detailList;   

                    }else if(key==3){ //发送中统计
                        this.totalSendNumING = result.totalSendNumF;
                        this.plateformNumING = result.plateformNumF;
                        this.dynamicNumING = result.dynamicNumF;
                        this.shopNumING = result.shopNumF;
                        this.realtotalSendNumING = result.realtotalSendNumF;
                        this.realplateformNumING = result.realplateformNumF;
                        this.realdynamicNumING = result.realdynamicNumF;
                        this.realshopNumING = result.realshopNumF;

                        // 饼图数据
                        this.analysisdateDataList = res.data.data;
                        document.getElementById("chartname5").style.height = "500px";
                        this.analysisdateChart = this.$echarts.init(document.getElementById("chartname5"));
                        let optionA = this.getPieOption(this.analysisdateDataList);
                        this.analysisdateChart.setOption(optionA);
                        this.data_failrate=  res.data.data.detailList;   

                    }else if(key=='analysisDate'){ // 日期查询柱状图
                        this.analysisdateDataList = res.data.data;
                        document.getElementById("chartname1").style.height = "500px";
                        this.analysisdateChart = this.$echarts.init(document.getElementById("chartname1"));
                        let optionA = this.getAnalysisOption(this.analysisdateDataList);
                        this.analysisdateChart.setOption(optionA);
                        this.data_failrate=  res.data.data.detailList;   
                    }else if(key=='analysisDate_line'){ // 日期查询折线图
                        this.analysisdateDataList = res.data.data;
                        document.getElementById("chartname4").style.height = "500px";
                        this.analysisdateChart = this.$echarts.init(document.getElementById("chartname4"));
                        let optionA = this.getAnalysisLineOption(this.analysisdateDataList);
                        this.analysisdateChart.setOption(optionA);
                        this.data_failrate=  res.data.data.detailList;   
                    }
                    
                }
            })
        },


        // 短信发送数柱状图
        getAnalysisOption(aDataList){
            // 绘制图表配置
            let option = {};
            option = {
                legend: {},
                tooltip: {},
                dataset: {
                    source:  aDataList.retdata
                },
                xAxis: {type: 'category'},
                yAxis: {},
                series: [
                    {type: 'bar'},
                    {type: 'bar'},
                    {type: 'bar'}
                ]
            };
            return option
        },

        // 短信发送数折线图
        getAnalysisLineOption(aDataList){
            // 绘制图表配置
            let option = {};
            option = {
                title: {
                    text: '折线图'
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data:aDataList.yAxis_legend
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: aDataList.xAxis_date,
                    axisLabel:{formatter:'{value}'}
                },
                yAxis: {
                    type: 'value'
                },
                series:aDataList.yAxis_datelist
            };
            return option
        },

        // 占比饼图
        getPieOption(dateList){

            let option = {
                title: {
                    text: '短信占比图',
                    subtext: '',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',
                    left: 'left',
                },
                series: [
                    {
                        name: '访问来源',
                        type: 'pie',
                        radius: '50%',
                        data: dateList.pieList,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            };

            return option
        },

        handleSearchReset(){
            this.$store.dispatch({
                type: "smsmanager/getEmptySearchAnalysis",
                showMsg: true
            })
            this.searchP.starttime=this.dateFormat('YYYY-mm-dd',new Date());
            this.searchP.endtime=this.dateFormat('YYYY-mm-dd',new Date());
        },

        handleSubmit(e){
            e.preventDefault();
  
            if((this.analysistype=='analysisDate' ||this.analysistype=='analysisDate_line')){
                if(this.searchP.starttime==null || this.searchP.endtime==null ){
                    this.message.error('时间轴请选择日期区间')   ;
                    return;
                }
            }
            this.getSmsAnalysis(this.analysistype);
        },

        dateFormat(fmt, date) {
            let ret;
            const opt = {
                "Y+": date.getFullYear().toString(),        // 年
                "m+": (date.getMonth() + 1).toString(),     // 月
                "d+": date.getDate().toString(),            // 日
                "H+": date.getHours().toString(),           // 时
                "M+": date.getMinutes().toString(),         // 分
                "S+": date.getSeconds().toString()          // 秒
            // 有其他格式化字符需求可以继续添加，必须转化成字符串
            };
            for (let k in opt) {
                ret = new RegExp("(" + k + ")").exec(fmt);
                if (ret) {
                    fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
                }
            }
            return fmt;
        },

    },
    computed:{
        ...mapState('smsmanager', {
            searchP: state => state.searchPAnalysis,
        })
    },

    mounted(){
        this.searchP.starttime=this.dateFormat('YYYY-mm-dd',new Date());
        this.searchP.endtime=this.dateFormat('YYYY-mm-dd',new Date());
        this.getSmsAnalysis(1);
    }
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
td{
  padding: 10px 10px;
}
</style>
